import type { AdminOrderRequest, Order, OrderRequest, OrderRequestStatus, OrderRequestType } from '../types';

export const CANCELLATION_REASON_MIN = 10;
export const CANCELLATION_REASON_MAX = 2000;

export const ORDER_REQUEST_TYPE_LABELS: Record<OrderRequestType, string> = {
  cancellation: 'İptal Talebi',
  return: 'İade Talebi',
};

export const ORDER_REQUEST_STATUS_LABELS: Record<OrderRequestStatus, string> = {
  pending: 'Bekliyor',
  approved: 'Onaylandı',
  rejected: 'Reddedildi',
  withdrawn: 'Geri çekildi',
};

export function validateCancellationReason(reason: string): string | null {
  const trimmed = reason.trim();
  if (trimmed.length < CANCELLATION_REASON_MIN) {
    return `İptal nedeni en az ${CANCELLATION_REASON_MIN} karakter olmalıdır.`;
  }
  if (trimmed.length > CANCELLATION_REASON_MAX) {
    return `İptal nedeni en fazla ${CANCELLATION_REASON_MAX} karakter olabilir.`;
  }
  return null;
}

export function hasPendingOrderRequest(order: Order): boolean {
  return (order.requests ?? []).some((request) => request.status === 'pending');
}

export function getPendingCancellationRequest(order: Order): OrderRequest | undefined {
  return (order.requests ?? []).find(
    (request) => request.type === 'cancellation' && request.status === 'pending',
  );
}

export function canRequestCancellation(order: Order): boolean {
  if (order.status !== 'pending' && order.status !== 'processing') return false;
  return !hasPendingOrderRequest(order);
}

export function canAdminCancelOrder(order: Order): boolean {
  return order.status === 'pending' || order.status === 'processing';
}

export function getLatestCancellationRequest(order: Order): OrderRequest | undefined {
  return [...(order.requests ?? [])]
    .reverse()
    .find((request) => request.type === 'cancellation');
}

export function formatOrderRequestSummary(request: AdminOrderRequest): string {
  return `${ORDER_REQUEST_TYPE_LABELS[request.type]} — ${ORDER_REQUEST_STATUS_LABELS[request.status]}`;
}
